import React, { Component } from 'react';
import {
    Route, useLocation
  } from "react-router-dom";

import ListarEventos from '../ListadoEventos/ListarEventos';
import MainPage from "../Principal/mainPage";
import DetallesEvento from "../ListadoEventos/DetallesEvento";
import SearchDetail from "../HeaderComponents/SearchDetail";

class ModalSwitch extends Component {
   
    render() {
        
        const { idPais, urlPais, varPais } = this.props;
        
        return(
            <div>
                    {/**Configuracion de la ruta principal '/' */}
                    <Route exact path="/:pathParam?" children={<MainPage varPais={varPais}/>} />
                    
                    {/** Configuracion de la ruta listar bodas */}
                    <Route key="keyBoda" path="/:pathParam?/eventos-bodas" children={<ListarEventos eventType="2" key="listWed" desc="listaBoda"  idPais={idPais} urlPais={urlPais} varPais={varPais}/>} />
                    
                    {/** Configuracion de la ruta de listar regalos */}
                    <Route key="keyRegalo" path="/:pathParam?/eventos-regalos" children={<ListarEventos eventType="4" key="listReg" desc="listaRegalo" idPais={idPais} urlPais={urlPais} varPais={varPais} />} />
                    
                    <Route path="/:pathParam?/detalle-evento/:id"  component={DetallesEvento} />

                    <Route path="/:pathParam?/Search" children={<SearchHome pais={varPais} urlPais={urlPais} idPais={idPais}/>} />

            </div>
        );
    }

}

function SearchHome (props){  
    let location = useLocation();
    return (
      <SearchDetail varPais={props.pais} urlPais={props.urlPais} busqueda={location.state.busqueda} idPais={props.idPais} ></SearchDetail>
    )
}

export default ModalSwitch;